export default function (str) {
  return str
    .toLowerCase()
    .replace(' ', '_')
    .replace(/[^a-z_]/g, '')
}
